import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { FrameworkHelper, GlobalLoaderService } from '@brafton/angular-framework-library';
import { MasterProjectsService, ProductionsService } from '@brafton/atlas-api-client';
import { SearchHit } from '@brafton/atlas-api-client';

@Component({
  selector: 'search-result-box',
  templateUrl: './search-result-box.component.html',
  styleUrls: ['./search-result-box.component.scss'],
  host: { class: 'search-result-box' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchResultBoxComponent {
  @Input() menu = false;
  @Input() result?: SearchHit;
  @Input() route?: string;
  @Input() routeSuffix?: string;

  routing = new BehaviorSubject<boolean>(false);

  @HostListener('click')
  onClick() {
    if (this.route) {
      this.router.navigate([this.route]);
      return;
    }
    if (!this.result?.project || this.routing.getValue()) return;
    this.routeToProjectOnClick(this.result);
  }

  @ViewChild('content') content!: ElementRef;

  @HostBinding('class') get classes() {
    const content = this.content?.nativeElement?.innerText !== '' ? 'has-content' : '';
    const route = this.route || this.result ? 'has-route' : '';
    return `${content} ${route}`;
  }

  constructor(
    private frameworkHelper: FrameworkHelper,
    private router: Router,
    private productionsService: ProductionsService,
    private loaderService: GlobalLoaderService,
    private masterProjectsService: MasterProjectsService,
  ) {}

  async routeToProjectOnClick(result: any) {
    if (!result?.project || this.routing.getValue()) return;
    const loaderTask = this.loaderService.startGlobalTask();
    try {
      this.routing.next(true);
      const project = await this.getProjectOnId(result?.project?.id, result?.project?.module);
      const route = this.frameworkHelper.findProjectRoute(project);
      const routeWithSuffix = route + (this.routeSuffix ?? '');
      this.router.navigate([routeWithSuffix]);
      this.loaderService.stopTask(loaderTask);
    } catch (error) {
      console.log('Error In Project Routing:', error);
      this.routing.next(false);
      this.loaderService.stopTask(loaderTask);
    }
  }

  async getProjectOnId(id: string, module: string): Promise<any> {
    // Master Project
    if (module === 'MasterProject') {
      const data = await this.masterProjectsService.getProjectDetails(id).pipe(take(1)).toPromise();
      return data;
    }

    // Internal Project - this is duplicate call the same as master projects for now but may change in the future
    if (module === 'InternalProject') {
      const data = await this.masterProjectsService.getProjectDetails(id).pipe(take(1)).toPromise();
      return data;
    }

    // Default to Production
    const data = await this.productionsService.getProductionDetails(id).pipe(take(1)).toPromise();
    return data;
  }
}
